<template>
  <SortSearch default-sort="latest" dimension="LatestVectors" :force-experience="getDesign" />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  computed: {
    ...mapGetters('experience', ['getDesign'])
  },
  nuxtI18n: {
    paths: {
      en: '/design/latest-vectors/p/:page',
      es: '/design/ultimos-vectores/p/:page',
      pt: '/design/novos-vetores/p/:page',
      de: '/design/neue-vektoren/p/:page'
    }
  },
  head() {
    return {
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex, follow' }]
    };
  }
};
</script>
